export default class SearchParamsHelper {
  static getPageLink(page: number, queryParams: any) {
    return this.setQueryParamAndReturnString(
      queryParams,
      "page",
      page.toString()
    );
  }

  static setSortParam(sortValue: string, queryParams: any) {
    return this.setQueryParamAndReturnString(queryParams, "orderBy", sortValue);
  }

  static setQueryParamAndReturnString(
    queryParams: any,
    key: string,
    value: string
  ) {
    let newQueryParams = { ...queryParams };
    newQueryParams[key] = value;
    let queryString = "";

    Object.keys(newQueryParams).forEach((key) => {
      queryString += `${key}=${newQueryParams[key]}&`;
    });

    queryString = queryString.slice(0, -1);

    return queryString;
  }
}
